__turbopack_context__.v({
  "chartSection": "MalwareTrends-module-scss-module__s1M0sq__chartSection",
  "pieChartTitle": "MalwareTrends-module-scss-module__s1M0sq__pieChartTitle",
});
